import { gql } from "@apollo/client";

const SAVE_PROCEDIMIENTO_PRESENCIAL_AE = gql`
    mutation saveVisitaPresencialAEProcedimiento($input: AddVisitaPresencialAEProcedimientoInput!){
        saveVisitaPresencialAEProcedimiento(input: $input) {
            idPresencialAE
            idVisita
        }
    }
`;

export default SAVE_PROCEDIMIENTO_PRESENCIAL_AE;

export const adaptAddVisitaPresencialAEProcedimientoInput = (data) => ({
  idPresencialAE: data?.idPresencialAE,
  tensionArterial: data?.tensionArterial,
  temperatura: data?.temperatura,
  frecuenciaCardiaca: data?.frecuenciaCardiaca,
  frecuenciaRespiratoria: data?.frecuenciaRespiratoria,
  fijacionAcceso: !!data?.fijacionAcceso,
  curacionAcceso: !!data?.curacionAcceso,
  bombaInfusion: !!data?.bombaInfusion,
  cambioSonda: !!data?.cambioSonda,
  controlPH: !!data?.controlPH
});